import React from 'react'
import { Button } from '@wallyhealth/web-core'
import classes from 'classnames'
import styles from './index.module.css'
import ChatLink from 'components/ChatLink'

const EmptySlots = ({ onTryAgain, isCentered }) => (
  <div className={styles.container}>

    <div
      className={classes({
        [styles.info]: true,
        [styles.centered]: isCentered
      })}>
      <span className={styles.message}>
        We couldn't find any available appointment times. Feel free to
      </span>
      <ChatLink
        text="chat with us"
        className={styles.chat}
      />
      <span className={styles.message}>
        .
      </span>
    </div>

    <Button
      label="Try again just in case"
      onClick={onTryAgain}
      className={styles.button}
    />
  </div>
)

export default EmptySlots
